export enum OtaFirmwareVersionType {
  SPINE = 'spine',
  VALVE = 'valve'
}
